import { Suspense } from "react";
import { Outlet } from "react-router-dom";
import RouteFallback from "../../app/routing/fallback/RouteFallback";

export default function PublicLayout() {
  return (
    <Suspense fallback={<RouteFallback />}>
      <Outlet />
    </Suspense>
  );
}
